import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { application_confirm, application_suggest } from "../../admin/admin.api";
import "./applicationResponse.css";

export default function ApplicationResponse() {
  const { id } = useParams();
  const history = useHistory();
  const [showSuggestionInput, setShowSuggestionInput] = useState(false);
  const [suggestionText, setSuggestionText] = useState("");

  const handleConfirmation = () => {
    const form = new FormData();
    form.append("application_id", id);
    form.append("status_id", "2");
    form.append("id", id);

    application_confirm(id, form)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: res.message ?? "Confirmed successfully",
        }).then(() => {
          history.push("/");
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: err.response?.data?.message || "Failed to submit confirmation",
        });
      });
  };

  const handleSuggestion = () => {
    setShowSuggestionInput(true);
  };

  const submitSuggestion = () => {
    if (suggestionText.trim()) {
      const form = new FormData();
      form.append("application_id", id);
      form.append("suggestion", suggestionText);
      form.append("id", id);

      application_suggest(id, form)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: res.message ?? "Suggestion submitted successfully",
          }).then(() => {
            history.push("/");
          });
          setShowSuggestionInput(false);
          setSuggestionText("");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: err.response?.data?.message || "Failed to submit suggestion",
          });
        });
    }
  };

  const cancelSuggestion = () => {
    setShowSuggestionInput(false);
    setSuggestionText("");
  };


  return (
    <div className="application-response-container">
      <div className="response-card">
        <div className="card-header">
          <h2>Application Response</h2>
          {/* <div className="application-id">
            Application ID: {id}
          </div> */}
        </div>

        <div className="card-body">
          <div className="action-section">
            <h3>Take Action</h3>
            <p>Please choose your response for this application:</p>
            
            <div className="action-buttons">
              <button
                onClick={handleConfirmation}
                className="btn btn-confirmation"
              >
                <span className="btn-icon">✓</span>
                Confirm
              </button>
              
              <button
                onClick={handleSuggestion}
                className="btn btn-suggestion"
              >
                <span className="btn-icon">💡</span>
                Suggestion
              </button>
            </div>

            {showSuggestionInput && (
              <div className="suggestion-input-section">
                <div className="suggestion-form">
                  <textarea
                    value={suggestionText}
                    onChange={(e) => setSuggestionText(e.target.value)}
                    placeholder="Enter your suggestion here..."
                    className="suggestion-textarea"
                    rows="4"
                  />
                  <div className="suggestion-buttons">
                    <button
                      onClick={submitSuggestion}
                      className="btn btn-submit-suggestion"
                    >
                      Submit Suggestion
                    </button>
                    <button
                      onClick={cancelSuggestion}
                      className="btn btn-cancel-suggestion"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="action-notes">
              <p>
                <strong>Confirm:</strong> Accept and confirm the application details.
              </p>
              <p>
                <strong>Suggestion:</strong> Provide suggestions or feedback for the application.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
